<script setup lang="ts">
import { $createParagraphNode, $getSelection, $isRangeSelection, $isTextNode } from "lexical";
import { useLexicalComposer } from "lexical-vue";

import { fillNodeWithMarkdown } from "../transformers";

const editor = useLexicalComposer();

const insert = (markdown: string) => {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }

    let trailingParagraph: ReturnType<typeof $createParagraphNode> | null = null;

    if (selection.isCollapsed()) {
      const { anchor } = selection;
      const anchorNode = anchor.getNode();

      if ($isTextNode(anchorNode)) {
        const { offset } = anchor;
        const length = anchorNode.getTextContentSize();

        if (offset > 0 && offset < length) {
          const [, trailingTextNode] = anchorNode.splitText(offset);
          trailingParagraph = $createParagraphNode();
          trailingParagraph.append(trailingTextNode);
          const leadingLength = anchorNode.getTextContentSize();
          selection.setTextNodeRange(anchorNode, leadingLength, anchorNode, leadingLength);
        }
      }
    }

    const paragraphNode = $createParagraphNode();
    selection.insertNodes([paragraphNode]);
    fillNodeWithMarkdown(paragraphNode, markdown);

    if (trailingParagraph !== null) {
      paragraphNode.insertAfter(trailingParagraph);
    }

    paragraphNode.selectEnd();
  });
};

defineExpose({
  insert,
});
</script>

<template>
  <slot />
</template>
